module.exports = __webpack_public_path__ + "img/menu_tk.896d629a.png";